module.exports = __webpack_public_path__ + "static/media/spw-global-income.1efb7ba1.csv";